import {cn} from 'platform/shared-tw';

import {PartSvg, type PartMode} from '../shared/PartSvg';
import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

const REAR_WINDSHIELD_LABEL = 'Rear Windshield';

interface RearWindshieldProps {
  readonly mode?: PartMode;
  readonly variant?: DiagramVariant;
  readonly onClick?: () => void;
}

export function RearWindshield(props: RearWindshieldProps) {
  return (
    <PartSvg
      mode={props.mode}
      onClick={props.onClick}
      label={REAR_WINDSHIELD_LABEL}
      width={180}
      height={360}
      viewBox="0 0 180 360"
      position={{top: 71, right: 162}}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M141 2C146 9 179 77 179 156V204C179 283 146 351 141 358C74.9999 356 24.9997 350 11.9997 338C0.801616 328.72 0.999714 311.83 0.999746 303L1.13354 180L0.999746 57C0.999714 48.1702 0.801616 31.2798 11.9997 22C24.9997 10 74.9999 4.00001 141 2ZM133 12C120.999 12 79.5542 14.3057 49.9997 18C25.9999 21 19.9997 32 19.9997 42V318C19.9997 328 25.9999 339 49.9997 342C79.5542 345.694 120.999 348 133 348C142 336 166.593 273.924 169.007 219.425C170 197 170 180 170 180C170 180 170 163 169.007 140.576C166.593 86.0764 142 24 133 12Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        opacity="0.8"
        d="M20 318V180V42C20 32 26 21 50 18C79.5546 14.3057 121 12 133 12C142 24 166.593 86.0759 169.007 140.576C170 163 170 180 170 180C170 180 170 197 169.007 219.424C166.593 273.924 142 336 133 348C121 348 79.5546 345.694 50 342C26 339 20 328 20 318Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M141 358C75 356 25 350 12 338C0.801728 328.72 0.999958 311.83 0.999991 303L1.13399 180L0.999991 57C0.999958 48.1702 0.801728 31.2797 12 22C25 10 75 4 141 2C146.001 9 179 77 179 156V180V204C179 283 146.001 351 141 358Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M20 318V180V42C20 32 26 21 50 18C79.5546 14.3057 121 12 133 12C142 24 166.593 86.0759 169.007 140.576C170 163 170 180 170 180C170 180 170 197 169.007 219.424C166.593 273.924 142 336 133 348C121 348 79.5546 345.694 50 342C26 339 20 328 20 318Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M34 219C34 226 20 228 20 228V132C20 132 34 134 34 141V180V219Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M20 228C20 228 34 226 34 219C34 219 34 189.22 34 180C34 170.78 34 141 34 141C34 134 20 132 20 132"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M29 135V180V225"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M20 132L20 180L20 228"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
    </PartSvg>
  );
}
